// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 71153, offsets 505079:505881. Structure and names inferred from code, not screenshots.

function ensureTracker() {
  if (window.onetrack) return;
  let e = document.createElement("script");
  ((e.src = "/offline/noop.js"),
    (e.async = true),
    document.body.append(e),
    (window.onetrack =
      window.onetrack ||
      function () {
        (onetrack.q = onetrack.q || []).push(arguments);
      }));
}
let o = false;
function initializeTracker() {
  o ||
    ((o = true),
    window.onetrack("mimo.init", 0x737c49a85, {
      region: "cn",
    }),
    window.onetrack("mimo.set", {
      system: "open-platform",
    }));
}
function disableTracker() {
  if (o) {
    for (let e of ((o = false),
    document.querySelectorAll('script[src*="pubsub"]')))
      e.remove();
    window.onetrack &&
      (window.onetrack.q && (window.onetrack.q = []), delete window.onetrack);
  }
}
function isTrackerInitialized() {
  return o;
}
function track(e, ...t) {
  window.onetrack && window.onetrack(`mimo.${e}`, ...t);
}
export {
  disableTracker,
  ensureTracker,
  track,
  initializeTracker,
  isTrackerInitialized,
};
